import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getNodeByKey, $getRoot, $getSelection, $isElementNode, $isParagraphNode, $isRangeSelection, $isTextNode } from "lexical";
import { useEffect } from "react";
import { $isDividerTextNode } from "../../nodes/DividerTextNode";
import { integerToRoman } from ".";
import { getLastPage } from "../../nodes/LayoutItemNode";
import { $getPageRoot, $isLayoutContainerNode } from "../../nodes/LayoutContainerNode";
import { $isEndNoteNode, getAllEndNoteNodes } from "../../nodes/EndNoteNode";
import { $isColoredNode } from "../../nodes/TableNode";

export default function EndnoteMonitorPlugin({showPagination = false}:any) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor) return;

    return editor.registerUpdateListener(({ editorState }) => {
      const paragraphsToRemove : any = [];

      editorState.read(() => {
        // Build set of active markers
        const activeMarkers = new Set();
        const romanNumeralsRegex = /^\[(i|ii|iii|iv|v|vi|vii|viii|ix|x|xi|xii|xiii|xiv|xv|xvi|xvii|xviii|xix|xx|xxi|xxii|xxiii|xxiv|xxv|xxvi|xxvii|xxviii|xxix|xxx)\]$/;
        const traverseForMarkers = (node : any) => {
          if ($isElementNode(node)) {
            ($isLayoutContainerNode(node) ? node.getAllChildren() : node.getChildren()).forEach((child:any) => traverseForMarkers(child));
          } else {
            const textContent = node.getTextContent().trim();
            if (romanNumeralsRegex.test(textContent)) {
              activeMarkers.add(textContent);
            }
          }
        };

        const root = showPagination === true ? $getPageRoot() : $getRoot()
        if(!root) return
        traverseForMarkers(root);

        // Check for special element in the DOM
        ($isLayoutContainerNode(root) ? root.getAllChildren() : root.getChildren()).forEach(child => {
          if ($isParagraphNode(child)) {
            const paragraphChildren = child.getChildren();
            paragraphChildren.forEach(subChild => {
              if ($isDividerTextNode(subChild)) {
                console.log('activeMarkers', activeMarkers)
                 if (activeMarkers.size === 0) {
                  console.log("[EndnoteMonitorPlugin] Removing dividerTextNode:", subChild);
                  paragraphsToRemove.push(subChild); // Mark it for removal
                }
              }
            });
          }
        });

        // Collect paragraphs to remove
        ($isLayoutContainerNode(root) ? root.getAllChildren() : root.getChildren()).forEach(child => {
          if ($isParagraphNode(child)) {
            const paraText = child.getTextContent().trim();
            const match = paraText.match(/\[\w+\]/);
            if (match) {
              const marker = match[0];
              if (!activeMarkers.has(marker)) {
                console.log(`[EndnoteMonitorPlugin] Will remove paragraph with orphan marker '${marker}':`, paraText);
                paragraphsToRemove.push(child);
              }
            }
          }
        });


        const AllEndnotes = getAllEndNoteNodes()
        if (AllEndnotes) {
          const selection = $getSelection();
          if ($isRangeSelection(selection)) {
            const nodeOnSelection = selection.anchor.getNode();
            const elemOnSelection = editor.getElementByKey(nodeOnSelection.getLatest().getKey())
            if ($isEndNoteNode(nodeOnSelection)) {
              const rootElement = editor.getRootElement();
              const spans = rootElement?.querySelectorAll('span') || [];
              const idspan =  Array.from(spans).find((span) => span.getAttribute('data-endnote')?.includes(`${nodeOnSelection.__attrId}`));
              if(idspan){
                elemOnSelection?.addEventListener('click',(e:MouseEvent)=>{
                  const cursor = getComputedStyle(elemOnSelection).cursor
                  if(cursor === 'pointer'){
                    idspan.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }
                })
              }
              
            }else if($isColoredNode(nodeOnSelection)){
              const rootElement = editor.getRootElement();
              const spans = rootElement?.querySelectorAll('span') || [];
              const idspan =  Array.from(spans).find((span) => nodeOnSelection.getId().includes(`${span.getAttribute('data-attr-endnote')}`));
              if(idspan){
                elemOnSelection?.addEventListener('click',(e:MouseEvent)=>{
                  const rect = elemOnSelection.getBoundingClientRect();
                  const clickx = e.clientX - rect.left;
                  if (clickx < rect.width / 3) {
                    idspan.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }
                })
              }
            }
            
          }
        }
        
        
      });

      // Now safely mutate outside the read()
      if (paragraphsToRemove.length > 0) {
      editor.update(() => {
        // Remove orphaned paragraphs
        paragraphsToRemove.forEach((paragraphNode: any) => {
          paragraphNode.remove();
        });

        // Now trigger renumbering again
        const root = $getRoot();
        const markers : any = [];
        const traverse = (node: any) => {
          if ($isElementNode(node)) {
            node.getChildren().forEach(traverse);
          } else if (node.getType && node.getType() === 'endnote') {
            markers.push(node);
          }
        };
        traverse(root);

        markers.forEach((marker : any, idx : any) => {
          const newNumber = idx + 1;
          marker.setNumber(newNumber);

          const contentKey = marker.getContentKey();
          const contentNode = $getNodeByKey(contentKey);
          if ($isParagraphNode(contentNode)) {
            const firstChild = contentNode.getFirstChild();
            if ($isTextNode(firstChild)) {
              const existingText = firstChild.getTextContent();
              const updatedText = existingText.replace(
                /^\[[^\]]*\]/,
                `[${integerToRoman(newNumber)}]`
              );
              if (updatedText !== existingText) {
                firstChild.setTextContent(updatedText);
              }
            }
          }
        });
      });

      }
    });
  }, [editor,showPagination]);

  return null;
}